import { Typography } from 'design-system/src/components/Typography/Typography';
import Hairline from 'design-system/src/components/Hairline/Hairline';
import Button from 'design-system/src/components/Button/Button';
import { PROVIDER_SUPPORT_CONTACT_INFO } from '../../../constants';
import type { EhrIntegrationFormProps } from './EhrIntegrationForm';
import { InstructionsFooter } from './InstructionsFooter';
import { InstructionsTitle } from './InstructionsTitle';
import { FormContainer, BodyContainer } from './styles';

/**
 * EHR integration instructions component for Veradigm
 */
export const VeradigmInstructions = ({ className }: EhrIntegrationFormProps) => {
  return (
    <FormContainer className={className}>
      <InstructionsTitle ehrDisplayName="Veradigm" />
      <Hairline className="!my-8" />
      <BodyContainer>
        <ol className="m-0 flex w-full list-none flex-col gap-8 p-0">
          <li className="flex flex-col gap-3">
            <Typography weight={600}>1. Email us with your information</Typography>

            <Typography>Send us an email with the following details:</Typography>

            <ul className="m-0 flex list-disc flex-col gap-2 p-0 pl-6">
              <li>
                <Typography>
                  <span className="font-bold">Client Account Number</span>
                </Typography>
              </li>
              <li>
                <Typography>
                  <span className="font-bold">Client Contact Email</span>
                </Typography>
              </li>
            </ul>
          </li>

          <li className="flex flex-col gap-3">
            <Typography weight={600}>2. Complete authorization forms from Veradigm</Typography>

            <Typography>
              You'll receive an email from Veradigm Connect with the subject line:{' '}
              <span className="font-bold">"Authorization Requested: API Activation (Tandem)"</span>. This email contains
              two short authorization forms — one for the EHR and one for PM — that need to be completed.
            </Typography>
          </li>

          <li className="flex flex-col gap-3">
            <Typography weight={600}>3. We'll handle the rest</Typography>

            <Typography>
              Once you submit both forms, we'll complete the integration on our end. Setup is typically complete within
              1–2 weeks. We'll confirm by email when you're live — and from that point on, no more document upload
              tasks.
            </Typography>
          </li>
        </ol>

        <div className="flex w-full gap-4">
          <Button
            variant="primary"
            href={`mailto:${PROVIDER_SUPPORT_CONTACT_INFO.email}?subject=Veradigm Integration Setup`}
          >
            Email us to get started
          </Button>
          <Button variant="secondary" href="/help-center">
            Schedule a training
          </Button>
        </div>
      </BodyContainer>
      <InstructionsFooter />
    </FormContainer>
  );
};
